module.exports = __webpack_public_path__ + "img/plus.d487d8a0.svg";